module.exports = __webpack_public_path__ + "static/media/block-4-beenleigh.78fde0f1.png";